<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
export default {
  name: 'CommentPreview',
  props: {
    comment: { type: String, default: null },
  },
  data() {
    return {
      clampLines: 2,
      isClamped: false,
      initialClamped: false,
    }
  },
  mounted() {
    const el = this.$refs.comment
    if (el) {
      this.isClamped = this.initialClamped = el.scrollHeight > el.clientHeight
    }
  },
  methods: {
    collapse() {
      this.clampLines = 2
      this.isClamped = true
    },
    expand() {
      this.clampLines = 0
      this.isClamped = false
    },
  },
}
</script>
